import {Component, EventEmitter, Input, Output} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserContent } from 'app/profile/model/model';

import {getTranslation} from 'shared/helpers/get-translation';
import { HyphenateService } from 'shared/helpers/hyphenate.service';

// twofold panel for userContent
@Component({
  selector: 'two-pane-cont',
  templateUrl: 'two-pane-cont.html',
  styleUrls: ['two-pane-cont.scss'],
})
export class TwoPaneCont {

  public title: string = '';
  public value: number;
  public total: number;
  public isSuggested: boolean = false;
  public isAvailable: boolean = false; // noch nicht gestartet, kann aber gestartet werden

  public _userContent: UserContent;
  
  @Input() public set userContent(userContent: UserContent) {
    this._userContent = userContent;
    this.title = getTranslation(userContent.contentFull.title, this.translateService);
    this.total = userContent.regularLength ? userContent.regularLength : userContent.contentFull.items.length;
    if ( userContent.state < 5 ) {
      this.isSuggested = userContent.suggest !== undefined && userContent.suggest > 0;
      this.isAvailable = !this.isSuggested && userContent.state < 5;
      this.value = 0;
    }
    else {
      this.value = userContent.curContentPos !== undefined ? userContent.curContentPos : this.total;
      if ( this.value > this.total ) {
        this.value = this.total;
      }
    }
  };

  @Output() public interactionClicked: EventEmitter<void> = new EventEmitter<void>();

  constructor(private translateService: TranslateService,
    private hyphenateService: HyphenateService) {};

  public onInteractionClicked(event: Event): void {
    event.stopPropagation();
    this.interactionClicked.emit();
  }

  public breakSafe(s: string): string {
    return this.hyphenateService.hyphenate(s);
  }

}
